import React from 'react';
import { Button } from './ui/button';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // ChunkLoadError happens when a new build is deployed and the user still has
    // the old index.html in memory — old chunk URLs 404. Auto-reload fixes it.
    const msg = error?.message || '';
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      msg.includes('Loading chunk') ||
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Importing a module script failed') ||
      msg.includes('error loading dynamically imported module');
    if (isChunkError) {
      // Avoid infinite reload loop: only reload once per session
      const reloadKey = 'tg247_chunk_reload';
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1');
        window.location.reload();
        return { hasError: false, error: null };
      }
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 text-center">
        <AlertTriangle className="h-16 w-16 text-red-400 mb-4" />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Có lỗi xảy ra</h1>
        <p className="text-gray-500 mb-2 max-w-sm">
          Ứng dụng gặp sự cố không mong muốn. Vui lòng tải lại trang.
        </p>
        {/* Only show error details in dev — prevent info leakage in production */}
        {process.env.NODE_ENV !== 'production' && this.state.error && (
          <p className="text-xs text-gray-400 mb-6 font-mono bg-gray-100 px-3 py-1 rounded max-w-sm truncate">
            {this.state.error.message}
          </p>
        )}
        <div className="flex gap-3">
          <Button variant="outline" onClick={() => window.location.reload()}>
            <RefreshCw className="h-4 w-4 mr-2" /> Tải lại
          </Button>
          <Button className="bg-blue-600 hover:bg-blue-700" onClick={() => { window.location.href = '/'; }}>
            <Home className="h-4 w-4 mr-2" /> Trang chủ
          </Button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
